$(document).on('keyup', e => {
  window.PubSub.publish('document:keyup', { which: e.which })
});



// WEBPACK FOOTER //
// ./scripts/lib/keyboard-events.js